import(/* webpackMode: "eager" */ "/vercel/path0/frontend/app/page.tsx")